module.exports = __webpack_public_path__ + "img/50c4dc9.png";